import type { FC, SVGProps } from 'react';

type SvgComponent = FC<SVGProps<SVGSVGElement>>;

/* ─── Navigation ─── */

export const HomeIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 10.5a1.5 1.5 0 01.5-1.13l7.5-6.75a1.5 1.5 0 012 0l7.5 6.75A1.5 1.5 0 0121 10.5V19a2 2 0 01-2 2H5a2 2 0 01-2-2v-8.5z" />
    <path d="M9 21V12a1 1 0 011-1h4a1 1 0 011 1v9" />
    <circle cx="7" cy="7" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

export const ProductsIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
    <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
    <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
    <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
    <circle cx="17.25" cy="17.25" r="2" fill="currentColor" stroke="none" opacity="0.3" />
  </svg>
);

export const NotificationsIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 01-3.46 0" />
    <circle cx="18" cy="5" r="2.5" fill="currentColor" stroke="none" />
  </svg>
);

/* ─── Actions ─── */

export const SearchIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="10.5" cy="10.5" r="7" />
    <path d="M21 21l-5.2-5.2" />
    <path d="M7 10.5h7" strokeWidth="1.5" opacity="0.4" />
  </svg>
);

export const PlusIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" opacity="0.12" fill="currentColor" stroke="none" />
    <path d="M8 12h8" />
    <path d="M12 8v8" />
  </svg>
);

export const ClockIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5V12l3.5 2" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" opacity="0.2" />
  </svg>
);

export const StarIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8 5.8 21.3l2.4-7.4L2 9.4h7.6z" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" opacity="0.3" />
  </svg>
);

/* ─── Role / Context ─── */

export const AdminIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 2L3 7v5c0 5.25 3.83 10.15 9 11 5.17-.85 9-5.75 9-11V7l-9-5z" />
    <path d="M9 12l2 2 4-4" strokeWidth="2.5" />
  </svg>
);

export const TeacherIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19.5v-10a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v10" />
    <path d="M12 9v10" />
    <path d="M4 19.5h16" />
    <path d="M9 9l3-5 3 5" />
    <circle cx="8" cy="14" r="1" fill="currentColor" stroke="none" opacity="0.3" />
    <circle cx="16" cy="14" r="1" fill="currentColor" stroke="none" opacity="0.3" />
  </svg>
);

export const StudentIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19.5V7.5a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v12" />
    <path d="M12 7v12" />
    <path d="M4 19.5h16" />
    <path d="M8 10h1" strokeWidth="1.5" />
    <path d="M15 10h1" strokeWidth="1.5" />
    <path d="M8 13h1" strokeWidth="1.5" />
    <path d="M15 13h1" strokeWidth="1.5" />
  </svg>
);

export const ParentIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="7" cy="7" r="2.5" />
    <circle cx="17" cy="7" r="2.5" />
    <path d="M2 17.5a5 5 0 015-5h0a5 5 0 015 5" />
    <path d="M12 12.5a5 5 0 015-5h0a5 5 0 015 5" />
    <circle cx="12" cy="17" r="1.5" fill="currentColor" stroke="none" opacity="0.3" />
    <path d="M12 17v-3" />
  </svg>
);

/* ─── Status ─── */

export const CheckIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12.5l2.5 2.5 5.5-6" strokeWidth="2.5" />
  </svg>
);

export const WarningIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
    <path d="M12 9v4" strokeWidth="2.5" />
    <path d="M12 17h.01" strokeWidth="2.5" />
  </svg>
);

export const ErrorIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M15 9l-6 6" strokeWidth="2.5" />
    <path d="M9 9l6 6" strokeWidth="2.5" />
  </svg>
);

export const InfoIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" strokeWidth="2.5" />
    <path d="M12 8h.01" strokeWidth="2.5" />
  </svg>
);

/* ─── UI / Controls ─── */

export const MenuIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 6h16" />
    <path d="M4 12h16" />
    <path d="M4 18h16" />
    <circle cx="20" cy="6" r="1.5" fill="currentColor" stroke="none" opacity="0.3" />
  </svg>
);

export const CloseIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" opacity="0.1" fill="currentColor" stroke="none" />
    <path d="M8 8l8 8" />
    <path d="M16 8l-8 8" />
  </svg>
);

export const ChevronRightIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 6l6 6-6 6" />
  </svg>
);

export const ChevronLeftIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export const GlobeIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" opacity="0.5" />
  </svg>
);

export const LogoutIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
    <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" opacity="0.3" />
  </svg>
);

export const SwitchIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M7 16l-4-4 4-4" />
    <path d="M17 8l4 4-4 4" />
    <path d="M3 12h18" />
  </svg>
);

export const ArrowUpwardIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 19V5" />
    <path d="M5 12l7-7 7 7" />
    <circle cx="12" cy="5" r="1" fill="currentColor" stroke="none" opacity="0.3" />
  </svg>
);

export const ExternalIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
    <path d="M15 3h6v6" />
    <path d="M10 14L21 3" />
  </svg>
);

/* ─── Small / Utility ─── */

export const CheckmarkIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

export const DotIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="none" {...props}>
    <circle cx="12" cy="12" r="4" />
  </svg>
);

/* ─── Empty State ─── */

export const NoAccessIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0110 0v4" />
    <circle cx="16" cy="18" r="3" fill="currentColor" stroke="none" opacity="0.15" />
    <path d="M14.5 18h3" strokeWidth="2.5" />
  </svg>
);

export const NoProductsIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
    <path d="M17 17l-3 3" opacity="0.5" />
    <path d="M14 17l3 3" opacity="0.5" />
  </svg>
);

export const NoNotificationsIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 01-3.46 0" />
    <path d="M3 3l18 18" opacity="0.5" />
  </svg>
);

/* ─── Brand Logo ─── */

export const LogoIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" fill="none" {...props}>
    <rect width="36" height="36" rx="8" fill="currentColor" />
    <text x="18" y="23" textAnchor="middle" fill="#fff" fontSize="18" fontWeight="700" fontFamily="'IBM Plex Sans', sans-serif">C1</text>
  </svg>
);

/* ─── Platform administration ─── */

export const InstitutionIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 21h18" />
    <path d="M5 21V9.5L12 5l7 4.5V21" />
    <path d="M9.5 21v-5h5v5" />
    <path d="M9 11.5h1.5" strokeWidth="1.5" />
    <path d="M13.5 11.5H15" strokeWidth="1.5" />
  </svg>
);

export const IntegrationIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M10.5 13.5l-2.3 2.3a3.5 3.5 0 01-5-5l2.3-2.3" />
    <path d="M13.5 10.5l2.3-2.3a3.5 3.5 0 015 5l-2.3 2.3" />
    <path d="M9 15l6-6" />
  </svg>
);

export const PulseIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 12h4l2.5-6 4 12 2.5-6H22" />
  </svg>
);

export const MailIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2.5" y="5" width="19" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

export const HistoryIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 12a9 9 0 109-9 9 9 0 00-6.6 2.9L3 8" />
    <path d="M3 3v5h5" />
    <path d="M12 7.5V12l3 1.8" />
  </svg>
);

export const ChecklistIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 6l2 2 3-3.5" />
    <path d="M3 13l2 2 3-3.5" />
    <path d="M3 20l2 2 3-3.5" />
    <path d="M11.5 6H21" />
    <path d="M11.5 13H21" />
    <path d="M11.5 20H21" />
  </svg>
);

export const FilterIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 5h18l-7 8v5.5l-4 2V13z" />
  </svg>
);

export const RefreshIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M20.5 12a8.5 8.5 0 11-2.5-6l2.5 2.5" />
    <path d="M21 3v5.5h-5.5" />
  </svg>
);

export const UsersIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="9" cy="8" r="3.25" />
    <path d="M2.5 19.5a6.5 6.5 0 0113 0" />
    <path d="M16 5.4a3.25 3.25 0 010 5.2" />
    <path d="M17.5 13.6a6.5 6.5 0 014 5.9" />
  </svg>
);

export const PauseIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M10 9v6" />
    <path d="M14 9v6" />
  </svg>
);

export const BanIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M5.6 5.6l12.8 12.8" />
  </svg>
);

export const ChevronDownIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

/* ─── Institution Admin ─── */

export const BuildingIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="4" y="2" width="16" height="20" rx="1" />
    <path d="M9 6h2" /><path d="M13 6h2" />
    <path d="M9 10h2" /><path d="M13 10h2" />
    <path d="M9 14h2" /><path d="M13 14h2" />
    <path d="M9 18h2" /><path d="M13 18h2" />
  </svg>
);

export const SettingsIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.32 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
  </svg>
);

export const ReportIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M8 13h8" /><path d="M8 17h8" /><path d="M8 9h2" />
  </svg>
);

export const TasksIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

export const BrandingIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v4" /><path d="M12 18v4" />
    <path d="M2 12h4" /><path d="M18 12h4" />
  </svg>
);

export const AcademicIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    <path d="M10 7h5" /><path d="M10 11h5" /><path d="M10 15h3" />
  </svg>
);

export const ProfileIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const CampusIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 21h18" />
    <path d="M5 21V7l8-4v18" />
    <path d="M19 21V11l-6-4" />
    <path d="M9 9h1" /><path d="M9 13h1" /><path d="M9 17h1" />
  </svg>
);

export const RoleIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87" />
    <path d="M16 3.13a4 4 0 010 7.75" />
  </svg>
);

export const InviteIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
    <circle cx="16" cy="16" r="4" fill="currentColor" opacity="0.2" stroke="none" />
    <path d="M16 14v4" strokeWidth="1.5" /><path d="M14 16h4" strokeWidth="1.5" />
  </svg>
);

export const AnnouncementIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22 2L11 13" />
    <path d="M22 2l-7 20-4-9-9-4 20-7z" />
  </svg>
);

export const PlatformIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <ellipse cx="12" cy="6" rx="8.5" ry="3.5" />
    <path d="M3.5 6v6c0 1.9 3.8 3.5 8.5 3.5s8.5-1.6 8.5-3.5V6" />
    <path d="M3.5 12v6c0 1.9 3.8 3.5 8.5 3.5s8.5-1.6 8.5-3.5v-6" />
  </svg>
);

export const SparklesIcon: SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 3l1.9 4.6 4.6 1.9-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9z" />
    <path d="M18.5 14.5l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z" />
    <path d="M5 3.5l.7 1.8 1.8.7-1.8.7L5 8.5l-.7-1.8-1.8-.7 1.8-.7z" />
  </svg>
);

/* ─── Registry ─── */

export const ICON_COMPONENTS: Record<string, SvgComponent> = {
  home: HomeIcon,
  products: ProductsIcon,
  notifications: NotificationsIcon,
  search: SearchIcon,
  plus: PlusIcon,
  clock: ClockIcon,
  star: StarIcon,
  admin: AdminIcon,
  teacher: TeacherIcon,
  student: StudentIcon,
  parent: ParentIcon,
  check: CheckIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
  menu: MenuIcon,
  close: CloseIcon,
  chevronRight: ChevronRightIcon,
  chevronLeft: ChevronLeftIcon,
  globe: GlobeIcon,
  logout: LogoutIcon,
  switch: SwitchIcon,
  arrowUpward: ArrowUpwardIcon,
  external: ExternalIcon,
  checkmark: CheckmarkIcon,
  dot: DotIcon,
  noAccess: NoAccessIcon,
  noProducts: NoProductsIcon,
  noNotifications: NoNotificationsIcon,
  logo: LogoIcon,
  institution: InstitutionIcon,
  integration: IntegrationIcon,
  pulse: PulseIcon,
  mail: MailIcon,
  history: HistoryIcon,
  checklist: ChecklistIcon,
  filter: FilterIcon,
  refresh: RefreshIcon,
  users: UsersIcon,
  pause: PauseIcon,
  ban: BanIcon,
  chevronDown: ChevronDownIcon,
  platform: PlatformIcon,
  building: BuildingIcon,
  settings: SettingsIcon,
  report: ReportIcon,
  tasks: TasksIcon,
  branding: BrandingIcon,
  academic: AcademicIcon,
  profile: ProfileIcon,
  campus: CampusIcon,
  role: RoleIcon,
  invite: InviteIcon,
  announcement: AnnouncementIcon,
  sparkles: SparklesIcon,
};
